/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconApiAppOff = createReactComponent("outline", "api-app-off", "IconApiAppOff", [["path", { "d": "M12 15h-6.5a2.5 2.5 0 1 1 0 -5h.5", "key": "svg-0" }], ["path", { "d": "M15 15v3.5a2.5 2.5 0 1 1 -5 0v-.5", "key": "svg-1" }], ["path", { "d": "M13 9h5.5a2.5 2.5 0 1 1 0 5h-.5", "key": "svg-2" }], ["path", { "d": "M9 12v-3m.042 -3.957a2.5 2.5 0 0 1 4.958 .457v.5", "key": "svg-3" }], ["path", { "d": "M3 3l18 18", "key": "svg-4" }]]);

export { IconApiAppOff as default };
//# sourceMappingURL=IconApiAppOff.mjs.map
